import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=1ad5a2b0"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=1ad5a2b0&prod&lang=css"
import style1 from "./Main.vue?vue&type=style&index=1&id=1ad5a2b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports